// extracted by mini-css-extract-plugin
export var categoryToggle = "survey-session-category-title-module--category-toggle--ofjX0";
export var surveyCategoryHeader = "survey-session-category-title-module--survey-category-header--YC8lY";